import type { RouterConfig } from '@nuxt/schema'
import type { LocationQuery } from 'vue-router'

type ArrayWithDelimiter = string[] & {
  delimiter: string
}

/**
 * @description Represents the list of characters which can be used for delimiting multi-value query params
 */
const DELIMITER_REGEX = new RegExp(/[|,]/, 'g')

// https://router.vuejs.org/api/interfaces/routeroptions.html
const config: RouterConfig = {
  parseQuery(search): LocationQuery {
    const params = new URLSearchParams(search)
    const finalQuery: LocationQuery = {}

    for (const key of params.keys()) {
      const value = params.get(key)

      if (!value) {
        finalQuery[key] = value
        // skip processing for null values
        continue
      }

      const matched = value.match(DELIMITER_REGEX)

      if (matched?.length) {
        const [delimiter] = matched
        const values = value.split(DELIMITER_REGEX) as ArrayWithDelimiter

        Object.defineProperty(values, 'delimiter', {
          value: delimiter,
          writable: false,
          enumerable: false,
          configurable: true,
        })

        finalQuery[key] = values
      } else {
        finalQuery[key] = value
      }
    }

    return finalQuery
  },
  scrollBehavior() {
    return
  },
  stringifyQuery(query) {
    const params: Record<string, string> = {}

    for (const key in query) {
      const value = query[key]

      if (Array.isArray(value)) {
        params[key] = value.join((value as ArrayWithDelimiter).delimiter || ',')
      } else {
        params[key] = query[key] as string
      }
    }

    return new URLSearchParams(params).toString()
  },
}

export default config
